import axios from 'axios';

export const bottlingPlanService = {
  // Get a single bottling plan with details
  async getPlan(planId) {
    try {
      const response = await axios.get(`/api/bottling-plans/${planId}`);
      return response.data;
    } catch (error) {
      throw new Error('Failed to fetch bottling plan: ' + error.message);
    }
  },
  
  // Create a new bottling plan
  async createPlan(planData) {
    try {
      const response = await axios.post('/api/bottling-plans', planData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to create bottling plan: ' + error.message);
    }
  },
  
  // Update existing bottling plan
  async updatePlan(planId, planData) {
    try {
      const response = await axios.put(`/api/bottling-plans/${planId}`, planData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update bottling plan: ' + error.message);
    }
  },
  
  // Add item to a bottling plan
  async addItem(planId, itemData) {
    try {
      const response = await axios.post(`/api/bottling-plans/${planId}/items`, itemData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to add item to plan: ' + error.message);
    }
  },
  
  // Update an item in a bottling plan
  async updateItem(planId, itemId, itemData) {
    try {
      const response = await axios.put(`/api/bottling-plans/${planId}/items/${itemId}`, itemData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to update item: ' + error.message);
    }
  },
  
  // Delete an item from a bottling plan
  async deleteItem(planId, itemId) {
    try {
      await axios.delete(`/api/bottling-plans/${planId}/items/${itemId}`);
      return true;
    } catch (error) {
      throw new Error('Failed to delete item: ' + error.message);
    }
  },
  
  // Finalize a bottling plan
  async finalizePlan(planId, finalizeData) {
    try {
      const response = await axios.post(`/api/bottling-plans/${planId}/finalize`, finalizeData);
      return response.data;
    } catch (error) {
      throw new Error('Failed to finalize plan: ' + error.message);
    }
  },
  
  // Get material stock information
  async getMaterialsStock() {
    try {
      const response = await axios.get('/api/materials/stock');
      
      // Process and categorize materials
      return response.data.reduce((acc, material) => {
        const category = material.categoryName?.toLowerCase() || '';
        
        if (category === 'glass' || category === 'bottles') {
          acc.bottles.push(material);
        } else if (category === 'corks') {
          acc.corks.push(material);
        } else if (category === 'capsules') {
          acc.capsules.push(material);
        } else if (category === 'labels') {
          acc.labels.push(material);
        }
        
        return acc;
      }, { bottles: [], corks: [], capsules: [], labels: [] });
    } catch (error) {
      throw new Error('Failed to fetch materials stock: ' + error.message);
    }
  }
};